export class FieldValidation {
    public fieldValidationId: number;
    public name: string;
    public code: string;
    public validationMessage: string;
    public validationValue: string;

    public static build(): FieldValidation {
        const fieldValidation: FieldValidation = new FieldValidation();
        fieldValidation.fieldValidationId = null;
        fieldValidation.name = null;
        fieldValidation.code = null;
        fieldValidation.validationMessage = null;
        fieldValidation.validationValue = null;
        return fieldValidation;
    }
}